export default "__VITE_ASSET__DGL$JwUQ__"